import { useState, useEffect, useRef } from 'react';
import MenuDropdowns from './MenuDropdowns';

const MenuItems = ({ items }) => {
  const [dropdown, setDropdown] = useState(false);
  const handleClicked = () => setDropdown(!dropdown);
  const closeNavMenu = () => setDropdown(false);

  const [windowDimension, detectWidth] = useState({
    winWidth: window.innerWidth
  });

  const detectSize = () => {
    detectWidth({
      winWidth: window.innerWidth
    });
  };

  useEffect(() => {
    window.addEventListener("resize", detectSize);

    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimension.winWidth]);

  if (windowDimension.winWidth < 992 && dropdown) {
    setDropdown(false);
  }

  let ref = useRef();
  
  // useEffect(() => {
  //   const handler = (event) => {
  //     if (dropdown && ref.current && !ref.current.contains(event.target)) {
  //       setDropdown(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handler);
  //   document.addEventListener("touchstart", handler);
  //   return () => {
  //    // Cleanup the event listener
  //     document.removeEventListener("mousedown", handler);
  //     document.removeEventListener("touchstart", handler);
  //   };
  // }, [dropdown]);
  
  return (
    <>
      {items.submenu ? (
        <>
          <li className="desktop-item" ref={ref}>
            <button className={dropdown ? `${"open-menu-btn"} nav-link` : `${"close-menu-btn"} nav-link`} type="button" aria-haspopup="menu" aria-expanded={dropdown ? "true" : "false"}
            onClick={handleClicked}>
            {/* onClick={() => setDropdown((prev) => !prev)}> */}
              {items.label}&nbsp;
              <span className={dropdown ? "open-dropdown-arrow" : "close-dropdown-arrow"}></span>
            </button>
          </li>
          <MenuDropdowns 
            submenus={items.submenu} 
            dropdowns={dropdown} 
            closeNavMenu={closeNavMenu} 
          />
        </>
      ) : (
        <li className="desktop-item">
          <a 
            className="nav-link"
            href={items.path}
            target={items.target}
            rel={items.rel}
            >
            <button className="menu-btn" type="button">
              {items.label}
            </button>
          </a>
        </li>
      )}
    </>
  );
};

export default MenuItems;